import { createRouter, createWebHistory } from 'vue-router';
import Home from '../pages/Home.vue';
import NotFound from '../pages/404.vue'; // Import your 404 component
import SuccessPage from '../pages/SuccessPage.vue'; // Import your 404 component

const routes = [
  {
    path: '/enroll', // No dynamic segment, only query params
    name: 'Home',
    component: Home,
  },
  {
    path: '/success',
    name: 'SuccessPage',
    component: SuccessPage
  },
  {
    path: '/:pathMatch(.*)*', // Wildcard route for 404
    name: 'NotFound',
    component: NotFound
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;